'use client';
import { Tag } from '@elsevier-health/osmosis-shared/types/learn';
import dynamic from 'next/dynamic';
import useModal from '../../hooks/useModal';
import { useEffect } from 'react';

const RetiredContentModal = dynamic(() => import('./RetiredContentModal'), {
  ssr: false,
});

type RetiredContentModalWrapperProps = {
  retiredPageTitle: string;
  retiredDate: string;
  tbrTag: Tag;
  triggerText?: string;
};

/**
 * Just a client component that will dynamic load the RetiredContentModal.
 */
const RetiredContentModalWrapper = ({
  retiredPageTitle,
  retiredDate,
  tbrTag,
}: RetiredContentModalWrapperProps) => {
  const modal = useModal();

  useEffect(() => {
    if (tbrTag) {
      modal.show();
    }
  }, [tbrTag]);

  return (
    <>
      {modal.isVisible && (
        <RetiredContentModal
          {...modal}
          retiredPageTitle={retiredPageTitle}
          retiredDate={retiredDate}
          tbrTag={tbrTag}
        />
      )}
    </>
  );
};

export default RetiredContentModalWrapper;
